// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".csv-table[data-v-615f0904] {\n  max-height: 333px;\n  overflow-y: auto;\n}\n.delete-btn[data-v-615f0904] {\n  margin-top: 24px;\n}\n.drop-file-container[data-v-615f0904] {\n  padding-bottom: 1.4rem;\n}", ""]);
// Exports
module.exports = exports;
